import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopoverModel } from '../info-popover/popover.model';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
})
export class InfoModalComponent implements OnInit {
  @Input() title?: string;
  @Input() popoverInfo?: PopoverModel;

  @ViewChild('modalTemplate') modalTemplate: any;

  modalRef!: NgbModalRef;

  constructor(public modalService: NgbModal) {}

  ngOnInit(): void {}

  openModal() {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      windowClass: 'modal-custom-lg',
    });
  }
}
